module.exports = __webpack_public_path__ + "static/media/S (49).0db13211.jpg";